const DEFAULT_VALUE = '0';

function attemptInsertComma(input: string | number) {
  return `${input}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const decimalPointMap: Record<string, (target: string | number | null | undefined) => number> = {
  roundDown: (target) => Math.floor(Number(target)),
  roundUp: (target) => Math.ceil(Number(target)),
  round: (target) => Math.round(Number(target)),
};

/**
 * Convert any target to currency
 * @param {string | number | null | undefined} target
 * @param {'roundDown' | 'roundUp' | 'round'} [decimalPoint='roundDown'] - roundDown(버림), roundUp(올림), round(반올림)
 * @returns {string}
 */
function toCurrency(
  target: string | number | null | undefined,
  decimalPoint?: 'roundDown' | 'roundUp' | 'round'
): string {
  if (!target) {
    return DEFAULT_VALUE;
  }

  if (!Number(target)) {
    return `${target}`;
  }

  const handleDecimalPoint = decimalPointMap[decimalPoint ?? 'roundDown'];

  return attemptInsertComma(handleDecimalPoint(target));
}

/**
 * Convert number typed target to currency
 * @param {string | number | null | undefined} target
 * @param {'roundDown' | 'roundUp' | 'round'} [decimalPoint='roundDown'] - roundDown(버림), roundUp(올림), round(반올림)
 * @returns {string}
 */
function toCurrencyStrict(
  target: string | number | null | undefined,
  decimalPoint?: 'roundDown' | 'roundUp' | 'round'
): string {
  if (!target) {
    return DEFAULT_VALUE;
  }

  if (!Number(target)) {
    return DEFAULT_VALUE;
  }

  const handleDecimalPoint = decimalPointMap[decimalPoint ?? 'roundDown'];

  return attemptInsertComma(handleDecimalPoint(target));
}

export { toCurrency, toCurrencyStrict };
